import React, {useCallback, useContext, useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types';
import {useDrop} from "react-dnd";
import {AcceptTypes, SourceTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import Column from "./Column";
import {checkChildrenDimensions} from "../../../../../../JsonScreen/Utils/checkForPercentHeight";
import {primaryDropColor} from "../ScreenBar";
import {useCurrentResolution} from "../../../../../../../Hooks/useCurrentResolution";

const Panel = ({panel = {}, index, path, parentPath}) => {
    const {onDropComponent, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const currentResolution = useCurrentResolution();
    const [direction, setDirection] = useState(null);
    const ref = useRef(null);
    const hasChildren = panel.children && panel.children.length;
    const [{isOver}, drop] = useDrop({
        accept: AcceptTypes.panel,
        collect: monitor => ({
            isOver: !!monitor.isOver()
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            const topBottomDirection = direction === 'top' ? index : index + 1;
            if (didDrop) {
                return
            }
            let newItem = {...item};
            //checking for children, if not, insert item into new panel
            if (item.children && item.children.length === 0 && (direction !== 'inner' && direction !== null)) {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                            //height: "50px",
                        }],
                        children: []
                    }]
                }
            }
            //drop top or bottom
            if (direction === 'top' || direction === 'bottom') {
                if (item.dragType === 'move') {
                    const newItem = item.type === 'panel' ? {
                        type: SourceTypes.panel,
                        styles: [{
                            width: "100%",
                            height: "50px",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: [{...item.component}]
                    } : item.component;
                    onMoveComponent(newItem, item.from, parentPath, topBottomDirection, item.index);
                    return
                }
                onDropComponent(newItem, topBottomDirection, parentPath);
                return
            }
            //if direction inner, just put in 0 position new item
            if (direction === 'inner') {
                onDropComponent(newItem, 0, `${path}.children`)
            }
        },
        hover: (item, monitor) => {
            if (!monitor.isOver({shallow: true})) {
                setDir(null);
                return
            }
            if (!ref.current) {
                return
            }
            const hoverBoundingRect = ref.current.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Dragging downwards
            if (hoverClientY < hoverMiddleY - 10) {
                setDirection('top');
                return;
            }
            // Dragging upwards
            if (hoverClientY > hoverMiddleY + 10) {
                setDirection('bottom');
                return;
            }

            setDirection('inner')
        }
    });
    const setDir = useCallback((dir) => {
        setDirection(dir)
    }, [direction]);

    useEffect(() => {
        if (!isOver) {
            setDir(null)
        }
    }, [isOver]);

    const styles = panel.styles ? panel.styles[0] : {};
    let {maximumHeight, maximumWidth} = checkChildrenDimensions(panel.children, currentResolution); //used for set height in to panel in percent from children
    drop(ref);
    return (
        <div ref={ref}
             style={{
                 padding: 1,
                 height: maximumHeight ? maximumHeight : styles.height,
                 width: maximumWidth ? '100%' : 'auto',
                 display: 'flex',
                 flexWrap: 'wrap',
                 borderTop: direction === 'top' ? `5px solid ${primaryDropColor}` : `${index % 2 === 0 ? '0 dashed gray' : '0 dashed gray'}`,
                 borderBottom: direction === 'bottom' ? `5px solid ${primaryDropColor}` : `0 dashed gray`,
             }}
        >
            {hasChildren ? (
                panel.children.map((item, i) => {
                    return (
                        <Column
                            key={`${path}.children.${i}`}
                            column={item}
                            index={i}
                            parentLength={panel.children.length}
                            parentIndex={index}
                            parentPath={path}
                            path={`${path}.children.${i}`}
                        />
                    )
                })
            ) : (
                <div
                    style={{
                        height: direction === 'inner' ? '10px' : 0,
                        background: primaryDropColor,
                        alignSelf: 'center',
                        width: '100%'
                    }}>

                </div>
            )}
        </div>
    )
};
export default Panel

Panel.propTypes = {
    panel: PropTypes.object,
    index: PropTypes.number,
    path: PropTypes.string,
    parentPath: PropTypes.string
};